module.exports = __webpack_public_path__ + "img/sidebar-1.61c4c50e.jpg";